import { useSetToastsState } from "../../app/hooks/useSetToastsState";
import { DataTestids } from "../miscellaneous/DataTestids";
import { OrderErrorKey } from "../miscellaneous/translationFromErrorCode";

export function useDismissToast() {
  const setToasts = useSetToastsState();

  return function (joiningKey: DataTestids | OrderErrorKey) {
    setToasts((items) => {
      return items?.filter((item) => item.joiningKey !== joiningKey) ?? [];
    });
  };
}
